import { useNavigate } from "react-router-dom";

import {
    Eye,
    Pencil,
    Trash2,
} from "lucide-react";

import LoadingAdminUsers from "./LoadingAdminUsers";
import EmptyAdminUsers from "./EmptyAdminUsers";

function AdminUserTable({

    admins,

    loading,

    reload,

    onDelete,

    onEdit,

}) {

    const navigate = useNavigate();

    const handleDelete = async (id) => {

        const confirmDelete = window.confirm(
            "Delete this admin user?"
        );

        if (!confirmDelete) return;

        await onDelete(id);

        reload();

    };

    if (loading) {

        return <LoadingAdminUsers />;

    }

    if (!admins.length) {

        return <EmptyAdminUsers />;

    }

    return (

        <div className="table-wrapper">

            <table className="admin-table">

                <thead>

                    <tr>

                        <th>Name</th>

                        <th>Email</th>

                        <th>Role</th>

                        <th>Status</th>

                        <th>Last Login</th>

                        <th>Actions</th>

                    </tr>

                </thead>

                <tbody>

                    {admins.map((admin) => (

                        <tr key={admin._id}>

                            <td>

                                <strong>

                                    {admin.fullName}

                                </strong>

                            </td>

                            <td>

                                {admin.email}

                            </td>

                            <td>

                                {admin.role?.roleName ||
                                    "-"}

                            </td>

                            <td>

                                <span
                                    className={`status-badge ${admin.status.toLowerCase()}`}
                                >

                                    {admin.status}

                                </span>

                            </td>

                            <td>

                                {admin.lastLogin
                                    ? new Date(
                                          admin.lastLogin
                                      ).toLocaleString()
                                    : "-"}

                            </td>

                            <td>

                                <div className="table-actions">

                                    <button
                                        className="view-btn"
                                        title="View"
                                        onClick={() =>
                                            navigate(
                                                `/admin/admin-users/${admin._id}`
                                            )
                                        }
                                    >

                                        <Eye size={18} />

                                    </button>

                                    <button
                                        className="edit-btn"
                                        title="Edit"
                                        onClick={() =>
                                            onEdit(admin)
                                        }
                                    >

                                        <Pencil size={18} />

                                    </button>

                                    <button
                                        className="delete-btn"
                                        title="Delete"
                                        onClick={() =>
                                            handleDelete(
                                                admin._id
                                            )
                                        }
                                    >

                                        <Trash2 size={18} />

                                    </button>

                                </div>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

}

export default AdminUserTable;